import { Badge, Layout, Menu } from 'antd';
import type { FC } from 'react';
import React from 'react';
import { Link, NavLink } from 'react-router-dom';

import { BuilderLogo } from 'app/components/commons/icons/BuilderLogo';

import 'styles/layout/side-menu.scss';

import './SideMenu.scss';

const { Sider } = Layout;

export const SideMenu: FC<Props> = ({ steps, step, validSteps }) => {
  const currentStep = steps.find((el) => el.order === step);
  const selectedKeys = currentStep ? [currentStep.key] : [];

  return (
    <Sider className="sider hotel-builder-sider">
      <Link to="/ext">
        <div className="title">
          <BuilderLogo />
        </div>
      </Link>
      <Menu
        theme="dark"
        className="menu"
        mode="inline"
        selectedKeys={selectedKeys}
        items={steps.map(({ key, title, order }) => {
          const state =
            order === step
              ? 'in-progress'
              : validSteps[order]
              ? 'done'
              : 'not-done';

          return {
            key,
            className: `standalone-item ${state}`,
            disabled: state !== 'in-progress',
            label: (
              <NavLink to="#">
                <div>
                  <Badge color="grey" />
                  {title}
                </div>
              </NavLink>
            ),
          };
        })}
      />
    </Sider>
  );
};

type Props = {
  steps: {
    key: string;
    title: string;
    order: number;
  }[];
  step: number;
  validSteps: {
    [key: string]: boolean;
  };
};
